<template>
  <div>
    <b-row>
      <b-col>
        <div class="mb-1 float-right" v-if="ableToCreatePackage">
          <router-link :to="{ name: 'EXABPackagesCreate' }" class="btn btn-primary">{{ $t('buttons.create') }}</router-link>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <div class="bcard-body">
            <div v-if="isLoadingPackages">
              <Loader></Loader>
            </div>
            <div v-else-if="getPackages.length < 1 && !isLoadingPackages">
              {{ $t('views.packages.list.noPackages') }}
            </div>
            <table class="table table-sm table-striped table-hover text-center" v-else>
              <thead>
              <tr>
                <th >{{ $t('global.title') }}</th>
                <th>{{ $t('views.agreements.form.dateFrom') }}</th>
                <th >{{ $t('views.agreements.form.dateTo') }}</th>
                <th >{{ $t('global.description') }}</th>
                <th style="width: 5%" ></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in getPackages" :key="item['@id']">
                <td>
                  {{ item.title }}
                </td>
                <td>
                  {{ item.dateFrom ? $moment(item.dateFrom).format('YYYY-MM-DD') : ' - ' }}
                </td>
                <td>
                  {{ item.dateTo ? $moment(item.dateTo).format('YYYY-MM-DD') : ' - ' }}
                </td>
                <td>
                  {{ item.description }}
                </td>
                <td>
                  <b-dropdown size="sm" variant="link" right text="Right align">
                    <template #button-content>
                      <i class="fa fa-bars fa-lg"></i>
                    </template>
                    <b-dropdown-item @click="showPackage(item['@id'])"><i class="fa fa-eye mr-2"></i>{{$t('buttons.preview')}}</b-dropdown-item>
                    <b-dropdown-item @click="editPackage(item['@id'])"><i class="fa fa-edit mr-2"></i>{{$t('buttons.edit')}}</b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <Pagination v-if="view" :view="view" @getPageNumber="getPage($event.page, $event.itemsPerPage)"></Pagination>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles'

export default {
  name: 'PackagesList',
  components: {
    Loader,
    Pagination
  },
  data () {
    return {
      items: []
    }
  },
  created () {
    this.fetchPackages()
  },
  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABPackagesList')
  },
  computed: {
    ...mapGetters({
      view: 'packages/list/getPackagesView',
      getPackages: 'packages/list/getPackages',
      isLoadingPackages: 'packages/list/getIsLoadingPackages'
    }),
    ableToCreatePackage () {
      return checkPermission('exabagreements', 'EXABPackagesCreate')
    }
  },
  watch: {
    '$route.query' () {
      this.fetchPackages(this.getBaseParams())
    }
  },
  methods: {
    editPackage (id) {
      this.$router.push({ name: 'EXABPackagesUpdate', params: { id: id } })
    },
    getPage (number, itemsPerPage = undefined) {
      let params = {}
      params['_page'] = number
      params['itemsPerPage'] = itemsPerPage
      this.fetchPackages(params)
    },
    showPackage (id) {
      this.$router.push({ name: 'EXABPackagesShow', params: { id: id } })
    },
    ...mapActions({
      fetchPackages: 'packages/list/fetchPackages'
    })
  }
}
</script>
